import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export class Rpe {
    public numVoo: string;
    public dateDTO: NgbDate;
    public company: string;
    public origin: string;
    public typeFlight: string;
}
